import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { searchAmazonItems } from '../../data-access/apis/authentication/amazon/common';
import { ResponseType } from '../../interfaces/response';
import { getExpirableItem, removeLocalStorageItem, setExpirableItem } from '../../utils/localStorage/localStorageUtil';

const LOCAL_STORAGE_KEY = 'amazon_search_items';

const initialItems = getExpirableItem<any[]>(LOCAL_STORAGE_KEY) || [];

const amazonSearchSlice = createSlice({
  name: 'amazon',
  initialState: {
    loading: false,
    status: ResponseType.Pending,
    statusCode: null,
    items: initialItems,
    message: null,
    error: null,
  },
  reducers: {
    resetAmazonSearch: (state) => {
      state.loading = false;
      state.status = ResponseType.Pending;
      state.statusCode = null;
      state.items = [];
      state.message = null;
      state.error = null;
      // 🧹 Remove from localStorage
      removeLocalStorageItem(LOCAL_STORAGE_KEY);
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(searchAmazonItems.pending, (state) => {
        state.loading = true;
        state.status = ResponseType.Pending;
        state.message = null;
        state.error = null;
      })
      .addCase(searchAmazonItems.fulfilled, (state, action: AnyAction) => {
        state.loading = false;
        state.status = ResponseType.Success;
        state.statusCode = action.payload.status;
        state.items = action.payload.data; // assuming data contains list of items
        state.message = action.payload.message;

        // ✅ Save to localStorage for 24 hours
        setExpirableItem(LOCAL_STORAGE_KEY, action.payload.data, 24 * 60 * 60 * 1000); // 24 hrs
      })
      .addCase(searchAmazonItems.rejected, (state, action: AnyAction) => {
        state.loading = false;
        state.status = ResponseType.Failed;
        state.statusCode = action.payload?.status || 500;
        state.error = action.payload || 'Something went wrong';
        console.log('action rejected', action)
      });
  }
});

export const { resetAmazonSearch } = amazonSearchSlice.actions;
export default amazonSearchSlice.reducer;
